function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "pixel-this-clothing-/-icons-/-pen---dark",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(7.529869, 8.997050) rotate(-315.000000) translate(-7.529869, -8.997050) translate(5.029869, -0.502950)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle",
  stroke: "#363636",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "translate(2.114894, 9.553853) rotate(-360.000000) translate(-2.114894, -9.553853) ",
  points: "-5.2846616e-13 0.739999013 4.2297886 0.739999013 4.2297886 14.6500139 2.0937762 18.3677077 -5.2846616e-13 14.6500139"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#363636",
  transform: "translate(2.114894, 8.901516) scale(1, -1) rotate(360.000000) translate(-2.114894, -8.901516) ",
  x: -7.50510765e-14,
  y: 3.67502135,
  width: 4.2297886,
  height: 10.4529888
})), /*#__PURE__*/React.createElement("line", {
  x1: 0.891546552,
  y1: 15.4989448,
  x2: 14.3065755,
  y2: 15.4989448,
  id: "Path-23",
  stroke: "#363636",
  strokeLinecap: "round"
}));

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pixel this clothing / icons / pen - dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.8978a2cc.svg";
export { ForwardRef as ReactComponent };